// Texty rychlého náhledu produktu z upsellu — slovenské dvojče locale/cs/upsellQuickView.js.
export default {
  title: 'Rýchly náhľad',
  closeLabel: 'Zavrieť',
  doneLabel: 'Zavrieť',
  pageLabel: 'Celý detail produktu',
  loading: 'Načítavame informácie o produkte…',
  error: 'Podrobnosti sa teraz nepodarilo načítať.',
  add: 'Pridať k objednávke',
  added: 'Pridané k objednávke',
  variant: 'Vybrať variant na detaile',
  params: 'Parametre',
  paramsAll: 'Všetky parametre',
  rating: 'hodnotení',
  delivery: 'Doručíme',
  photo: 'Fotka',
};
